import md5 from "blueimp-md5";
import { normalizeIcon } from "./react-plucked-map";
import type { RemoteIcon } from "../remote-icon-type";

export function getIconPath(icon: RemoteIcon) {
    if (!/^[0-9]/.test(icon)) {
        icon = normalizeIcon(icon);
    }
    let sliceAmount = 3;
    if (/^[0-9][0-9]-[0-9][0-9]-.*$/.test(icon)) {
        sliceAmount = 6;
    }

    const cacheBustNumber = 1;
    const file = icon.slice(sliceAmount) + `.svg`;
    const result = "/icons/" + md5(file) + `-${cacheBustNumber}.svg`;
    return result;
}

export function iconDisplayName(icon: RemoteIcon): string {
    let sliceAmount = 1;
    if (/^[0-9][0-9]-[0-9][0-9]-.*$/.test(icon)) {
        sliceAmount = 2;
    }
    return icon
        .split("-")
        .slice(sliceAmount)
        .map(s => s[0].toUpperCase() + s.slice(1))
        .join(" ");
}

export function dirDisplayName(dir: string): string {
    return dir
        .split("-")
        .slice(1)
        .map(s => s[0].toUpperCase() + s.slice(1))
        .join(" ");
}
